import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';
function ContextAwareToggle(_ref) {
  var children = _ref.children,
    eventKey = _ref.eventKey,
    callback = _ref.callback,
    isFetching = _ref.isFetching,
    isFetchingKey = _ref.isFetchingKey;
  var _useContext = useContext(AccordionContext),
    activeEventKey = _useContext.activeEventKey;
  var handleClick = useAccordionButton(eventKey, function () {
    if (callback) callback(eventKey);
  });
  var isActive = (Array.isArray(activeEventKey) ? activeEventKey[0] : activeEventKey) === eventKey;
  var showSpinner = isFetching && isFetchingKey === eventKey;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClick,
    className: "fs-6 fw-normal d-flex justify-content-between w-100 border-0 bg-transparent"
  }, children, showSpinner ? /*#__PURE__*/React.createElement("span", {
    className: "spinner-border spinner-border-sm ms-2 text-success",
    role: "status",
    "aria-hidden": "true"
  }) : /*#__PURE__*/React.createElement("span", {
    className: "text-white"
  }, isActive ? 'Close' : 'Expand'));
}
function ProjectIndexListGroup(_ref2) {
  var _ref2$count = _ref2.count,
    count = _ref2$count === void 0 ? 0 : _ref2$count,
    _ref2$classes = _ref2.classes,
    classes = _ref2$classes === void 0 ? '' : _ref2$classes,
    status = _ref2.status,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title,
    children = _ref2.children,
    _ref2$setCurrentActiv = _ref2.setCurrentActiveKey,
    setCurrentActiveKey = _ref2$setCurrentActiv === void 0 ? function () {} : _ref2$setCurrentActiv,
    _ref2$isFetching = _ref2.isFetching,
    isFetching = _ref2$isFetching === void 0 ? false : _ref2$isFetching,
    _ref2$isFetchingKey = _ref2.isFetchingKey,
    isFetchingKey = _ref2$isFetchingKey === void 0 ? '' : _ref2$isFetchingKey;
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-4",
    id: status
  }, /*#__PURE__*/React.createElement(Card.Header, {
    as: "div",
    className: classes
  }, /*#__PURE__*/React.createElement(ContextAwareToggle, {
    eventKey: status,
    callback: setCurrentActiveKey,
    isFetching: isFetching,
    isFetchingKey: isFetchingKey
  }, /*#__PURE__*/React.createElement("small", {
    role: "button",
    tabIndex: 0
  }, title, count > 0 && /*#__PURE__*/React.createElement("span", {
    className: "badge rounded-pill bg-secondary ms-2"
  }, count)))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: status
  }, /*#__PURE__*/React.createElement("ul", {
    className: "list-group list-group-hover"
  }, children)));
}
ProjectIndexListGroup.propTypes = {
  count: PropTypes.number,
  status: PropTypes.string.isRequired,
  title: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
  setCurrentActiveKey: PropTypes.func,
  isFetching: PropTypes.bool,
  isFetchingKey: PropTypes.string
};
export default ProjectIndexListGroup;